import Vue from 'vue';
import { isValidObject, SuperDate } from '@razlet/utils';
import Attachment from '../attachment';

const BID_STATUSES = {
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
  PROCESSING: 'process',
  CANCELED: 'canceled',
};

export default class ShipmentRefundBid {
  #data = {};

  #createdAt = null;

  #attachments = [];

  constructor (data) {
    if (!isValidObject(data)) return;

    this.#data = data;
    this.#createdAt = new SuperDate(data.createdAt);
    this.#attachments = data.attachments.map(attachment => new Attachment(attachment));
  }

  get id () {
    return this.#data.id;
  }

  get createdAt () {
    return this.#createdAt;
  }

  get attachments () {
    return this.#attachments;
  }

  get comment () {
    return this.#data.comment;
  }

  get createdBy () {
    return this.#data.createdBy;
  }

  get reason () {
    return this.#data.reason;
  }

  get localizedReason () {
    return Vue.prototype.$localize.t(`refundReasons.${this.reason}`);
  }

  get status () {
    return this.#data.status;
  }

  get localizedStatus () {
    return Vue.prototype.$localize.t(`shipments.refund.statuses.${this.status}`);
  }

  get isProcessing () {
    return this.status === BID_STATUSES.PROCESSING;
  }

  get isRejected () {
    return this.status === BID_STATUSES.REJECTED;
  }

  get isCanceled () {
    return this.status === BID_STATUSES.CANCELED;
  }
}
